const EventName = {
  /** Care+ flow: user selected who care is for (step 1, before contact). */
  CARE_PLUS_INQUIRY_RECIPIENT_SELECT: "care-plus-inquiry-recipient-select",
  /** Care+ inquiry (non–lead-form) submit outcome for Segment. */
  CARE_PLUS_INQUIRY_SUBMIT: "care-plus-inquiry-submit",
  CAREER_FORM_SUBMIT: "career-form-submit",
  CHAT_CONFIRMATION_SCREEN_SHOWN: "Chat Confirmation Screen Shown",
  CHAT_CONVERSATION_ENDED: "Chat Conversation Ended",
  CHAT_CONVERSATION_STARTED: "Chat Conversation Started",
  CHAT_EMAIL_COLLECTED: "Chat Email Collected",
  CHAT_ERROR: "Chat Error",
  CHAT_FIRST_NAME_COLLECTED: "Chat First Name Collected",
  CHAT_FORM_FALLBACK_SHOWN: "Chat Form Fallback Shown",
  CHAT_GENERAL_MESSAGE: "Chat General Message",
  CHAT_LAST_NAME_COLLECTED: "Chat Last Name Collected",
  CHAT_LEAD_SUBMITTED: "Chat Lead Submitted",
  CHAT_PHONE_COLLECTED: "Chat Phone Collected",
  CHAT_POSTAL_CODE_COLLECTED: "Chat Postal Code Collected",
  CHAT_WIDGET_OPENED: "Chat Widget Opened",
  /** V1 lead chatbot — Segment tracking plan (DEX-1983). */
  CHATBOT_LOADED: "Chatbot Loaded",
  CTA_BTN_INTERACTION: "cta-btn-interaction",
  /** Customer Service Form submit */
  CUSTOMER_SERVICE_FORM_SUBMIT: "Customer Service Form Submitted",
  /** Vercel Flags evaluation; emitted server-side once per (flag key, value) per request. */
  FEATURE_FLAG_EVALUATED: "Feature Flag Evaluated",
  /** Franchise inquiry submit outcome for Segment. */
  FRANCHISE_INQUIRY_SUBMIT: "franchise-inquiry-submit",
  /** LFB fullscreen takeover dismissed before completing the form (X button, Escape). */
  LEAD_FORM_EXIT: "Lead Form Exit",
  LEAD_FORM_STEP: "Lead Form Step",
  PHONE_NUMBER_CLICK: "phone-number-click",
  REQUEST_INFORMATION_FORM_SUBMIT: "request-information-form-submit",
  SERVICE_LEAD_FORM_SUBMIT: "service-lead-form-submit",
  TRACKED_CLICK: "tracked_click",
  URL_PARAMS: "URL Params",
};

export { EventName };
